/**
 * @generated SignedSource<<7bc94f701b3aa91e77afed22db1f69db>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type CompetitionNoCodeSubmissionPageUpdatePreambleMutation$variables = {
  competition: string;
  submissionPreamble?: string | null | undefined;
};
export type CompetitionNoCodeSubmissionPageUpdatePreambleMutation$data = {
  readonly updateCompetition: {
    readonly node: {
      readonly id: string;
      readonly submissionPreamble: string | null | undefined;
    };
  };
};
export type CompetitionNoCodeSubmissionPageUpdatePreambleMutation = {
  response: CompetitionNoCodeSubmissionPageUpdatePreambleMutation$data;
  variables: CompetitionNoCodeSubmissionPageUpdatePreambleMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "competition"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "submissionPreamble"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "competition"
      },
      {
        "fields": [
          {
            "kind": "Variable",
            "name": "submissionPreamble",
            "variableName": "submissionPreamble"
          }
        ],
        "kind": "ObjectValue",
        "name": "input"
      }
    ],
    "concreteType": "CompetitionEdge",
    "kind": "LinkedField",
    "name": "updateCompetition",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Competition",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "submissionPreamble",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "CompetitionNoCodeSubmissionPageUpdatePreambleMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "CompetitionNoCodeSubmissionPageUpdatePreambleMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "a11d45c3041a70392318def4cecb0115",
    "id": null,
    "metadata": {},
    "name": "CompetitionNoCodeSubmissionPageUpdatePreambleMutation",
    "operationKind": "mutation",
    "text": "mutation CompetitionNoCodeSubmissionPageUpdatePreambleMutation(\n  $competition: ID!\n  $submissionPreamble: String\n) {\n  updateCompetition(id: $competition, input: {submissionPreamble: $submissionPreamble}) {\n    node {\n      id\n      submissionPreamble\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "0d5662253b88c5891834d98d3319a997";

export default node;
